import { useGlobalState, usePiletApi } from "piral";
import { useLocation } from "react-router-dom";
import { IMenuItem } from "../interfaces/interfaces";

/**
 * Finds current pilet informations based on the current page (gets pilet which registered that page).
 * @returns current pilet object (model: Pilet type + some custom attributes)
 */
export default function useCurrentPilet() {
    
    const globalState = useGlobalState();
    const piletApi = usePiletApi();

    const currentPath = useLocation().pathname.slice(1);
    const pages = globalState.registry.pages;
    const currentPageName = Object.keys(pages).find(pageName => currentPath.startsWith(pageName));
    const currentPiletName = pages[currentPageName]?.pilet;


    if (!currentPiletName)
        return null;

    // get custom attributes exposed from pilet
    const prettyName: string = piletApi.getData(currentPiletName + ":prettyName");
    const rootPath: string = piletApi.getData(currentPiletName + ":rootPath");
    const homePath: string = piletApi.getData(currentPiletName + ":homePath");
    const menuItems: IMenuItem[] = piletApi.getData(currentPiletName + ":menuItems");
    
    // retrieve current Pilet object and build a new one injecting new custom attributes
    const currentPilet = globalState.modules.find(m => m.name.localeCompare(currentPiletName));
    const newAttributes = { prettyName, rootPath, homePath, menuItems };
    const customCurrentPilet = { ...currentPilet, ...newAttributes };

    return customCurrentPilet;
}